<template>
  <div v-if="policies.data.length" class="rounded border bg-white info-panel custom-table">
    <div class="table-responsive">
      <table
          class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800"
          style="white-space: nowrap!important;">
        <thead>
          <tr class="fw-bold fs-8 text-gray-400">
            <th class="w-95px">ID</th>
            <th>Локальный номер</th>
            <th>Глобальный номер</th>
            <th class="w-95px">Продукт</th>
            <th>Премия</th>
            <th>Направление</th>
            <th>Дата создания договора</th>
            <th>Создал</th>
            <th>Статус</th>
            <th>Дата создания заявки</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in policies.data" :key="key" class="align-middle" :class="disabledKey === key ? 'opacity-25' : ''">
            <td v-html="item.id"></td>
            <td v-html="item.policy.id"></td>
            <td v-html="item.policy.global_id"></td>
            <td v-html="item.policy.product_type"></td>
            <td>{{ item.policy.premium.toLocaleString('ru-RU') }} тг.</td>
            <td class="text-center" v-html="item.policy.insurer.person && item.policy.payment_type ? item.policy.isEpay ? 'Epay' : 'Kaspi' : 'Нал/Юр'"></td>
            <td v-html="item.policy.created_at"></td>
            <td v-html="item.creator.fio"></td>
            <td>
              <span class="px-3 py-1 rounded text-white fs-9 fw-bold" v-html="item.statusName" :class="getStyle(item.status)"></span>
            </td>
            <td v-html="item.created_at"></td>
            <td class="text-end">
              <i class="ki-outline ki-right-square text-primary fs-4 cursor-pointer" @click="getItemPolicy(key)"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <bootstrap5-pagination class="pagination-outline pt-3 mb-3 border-top" v-if="policies" :limit="5" :data="policies" @pagination-change-page="getPolicies"/>
    </div>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center rounded border bg-white info-panel fs-6 text-gray-400 custom-table h-200px">
    Нет информации
  </div>
</template>
<script>
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import axios                  from 'axios'

export default {
  name: 'PoliciesSupport',
  components: {
    Bootstrap5Pagination
  },
  props: {
    policies: null
  },
  computed: {
    today() {
      {
        const d    = new Date()
        let month  = '' + (d.getMonth() + 1)
        let day    = '' + d.getDate()
        const year = d.getFullYear()

        if (month.length < 2) month = '0' + month;
        if (day.length < 2)   day   = '0' + day;

        return [day, month, year].join('.');
      }
    }
  },
  data() {
    return {
      dataKey: 0,
      operatorErrorModalData: {
        resident: null,
        global:   null,
        person:   null,
        hash:     null,
        id:       null
      },
      disabledUpdate: false,
      disabledKey: null
    }
  },
  methods: {
    getStyle(status) {
      if (status === 0) return 'bg-primary'
      if (status === 1) return 'bg-success'
      if (status === 2) return 'bg-danger'
      if (status >= 3 && status <= 10) return 'bg-warning'
    },
    getPolicies(val) {
      this.$emit('reloaded', val)
    },
    getItemPolicy(key) {
      if (!this.disabledUpdate) this.$emit('open', this.policies.data[key])
    },
  }
}
</script>

<style></style>